<template>
	<div :class="['o-width-limiter o-width-limiter--main', className]">
		<div
			:class="[
				{
					'c-info-block--image-left': imageAlignment === 'left'
				},
				{
					'c-info-block--image-right': imageAlignment === 'right'
				},
				'o-grid',
				'c-info-block'
			]"
		>
			<div class="o-grid__column" data-size="md:12 lg:9">
				<div
					:class="[
						'c-info-block__content',
						color === 'orange' && 'c-info-block--orange',
						color === 'pink' && 'c-info-block--pink',
						color === 'blue' && 'c-info-block--blue',
						color === 'green' && 'c-info-block--green'
					]"
				>
					<div class="c-info-block__content-wrapper">
						<h2 class="c-info-block__heading heading-boarder">
							{{ heading }}
						</h2>
						<p v-if="text" class="c-info-block__text">{{ text }}</p>
						<a
							v-if="url && buttonText"
							:href="url"
							class="c-info-block__link"
						>
							<span>{{ buttonText }}</span>
							<v-icon
								:name="getIcon(url)"
								size="xxs"
								cssModifiers="c-info-block__icon"
							></v-icon>
						</a>
					</div>
				</div>
			</div>
			<img :src="src" :alt="alt || ''" class="c-info-block__image" />
		</div>
	</div>
</template>

<script>
import VIcon from "../../components/icon/VIcon.vue";

export default {
	name: "VInfoBlock",
	components: {
		VIcon
	},
	props: {
		heading: {
			type: String
		},
		text: {
			type: String
		},
		url: {
			type: String
		},
		buttonText: {
			type: String
		},
		src: {
			type: String
		},
		alt: {
			type: String
		},
		imageAlignment: {
			type: "right" | "left"
		},
		color: {
			type: "orange" | "blue" | "pink"
		},
		className: {
			type: String
		}
	},
		methods: {
		isExternalUrl(url) {
			return /^(http|https|\/\/)/.test(url) && !url.includes(window.location.hostname);
		},
		getIcon(url) {
			return this.isExternalUrl(url) ? "icon-external" : "icon-chevron";
		}
	},
};
</script>
